<section class="widget-page">
  <!-- Widget & More page -->
  <!-- Title & buttons -->
  <div class="d-flex align-items-center gap-3 mb-3">
    <div class="d-flex align-items-center gap-2">
      <h6 class="mb-0" i18n>Widgets & More</h6>
    </div>

    <div class="flex-fill"></div>
    <button routerLink="/websites" type="button" class="btn btn-secondary-primary">
      <ng-container i18n>Websites</ng-container>
      <span class="far fa-chevron-right"></span>
    </button>
  </div>

  <div class="d-grid gap-3" style="grid-template-columns: repeat(auto-fit, minmax(300px, 1fr))">
    <div class="d-flex flex-column align-items-center bg-white p-4 rounded shadow">
      <div class="badge badge-secondary-info badge-circle">
        <i class="cs-icon cs-icon-file-time"></i>
      </div>
      <div class="mt-3">
        <h6 class="d-flex align-items-center justify-content-center gap-2">
          <ng-container i18n>Inquiry Widget</ng-container>
          <app-page-help [articleId]="'zaokdn0igu'" videoId="-"></app-page-help>
        </h6>
        <p class="text-center" i18n>
          The AdvanceCM Inquiry Widget allows you to capture inquiries on any website by inserting an inquiry form on a
          webpage. The widgets come in three sizes that fit any website layout. You can customize the widget before
          inserting it onto your webpage. Place the widget on your website, blog, or any website that you can edit and
          start capturing more inquiries today.
        </p>
      </div>
      <div class="flex-fill"></div>
      <button
        routerLink="/widgets/inquiry"
        type="button"
        class="btn btn-secondary-info"
        [disabled]="1 | isReadonlyRole"
        i18n-matTooltip
        matTooltip="Create or edit an inquiry widget."
        matTooltipPosition="above"
      >
        <span class="cs-icon cs-icon-cog" aria-hidden="true"></span>
        <ng-container i18n>Configure</ng-container>
      </button>
    </div>

    <div class="d-flex flex-column align-items-center bg-white p-4 rounded shadow">
      <div class="badge badge-secondary-warning badge-circle">
        <i class="cs-icon cs-icon-calendar-alt2"></i>
      </div>
      <div class="mt-3">
        <h6 class="d-flex align-items-center justify-content-center gap-2">
          <ng-container i18n>Calendar Widget</ng-container>
          <app-page-help [articleId]="'iszbccfr9x'" videoId="-"></app-page-help>
        </h6>
        <p class="text-center" i18n>
          The AdvanceCM Calendar Widget allows you to display booking availability on any website. Use this simple and
          convenient tool to keep your prospective guests aware of what dates are available for booking. The calendar is
          completely editable and you may change the number of months displayed, colors, font, and more. Place the
          widget on your website, blog, or any website that you can edit and start displaying your availability to the
          world.
        </p>
      </div>
      <div class="flex-fill"></div>
      <button
        routerLink="/widgets/calendar"
        type="button"
        class="btn btn-secondary-info"
        [disabled]="1 | isReadonlyRole"
        matTooltip="Create or edit a calendar widget."
        matTooltipPosition="above"
      >
        <span class="cs-icon cs-icon-cog" aria-hidden="true"></span>
        <ng-container i18n>configure</ng-container>
      </button>
    </div>

    <div class="d-flex flex-column align-items-center bg-white p-4 rounded shadow">
      <div class="badge badge-secondary-success badge-circle">
        <i class="cs-icon cs-icon-calendar-time"></i>
      </div>
      <div class="mt-3">
        <h6 class="d-flex align-items-center justify-content-center gap-2">
          <ng-container i18n>Booking Widget</ng-container>
          <app-page-help [articleId]="'t22udsigx4'" videoId="-"></app-page-help>
        </h6>
        <p class="text-center" i18n>
          The AdvanceCM Booking Widget allows guests to book directly from your non-AdvanceCM website to your AdvanceCM
          booking engine. Simply configure the booking widget for a specific rental and booking engine, then place it on
          your site. You may even customize the widget to fit your website's look and feel.
        </p>
      </div>
      <div class="flex-fill"></div>
      <button
        routerLink="/widgets/booking"
        type="button"
        class="btn btn-secondary-info"
        [disabled]="1 | isReadonlyRole"
        matTooltip="Create or edit a booking widget."
        matTooltipPosition="above"
      >
        <span class="cs-icon cs-icon-cog" aria-hidden="true"></span>
        <ng-container i18n>configure</ng-container>
      </button>
    </div>

    <div class="d-flex flex-column align-items-center bg-white p-4 rounded shadow">
      <div class="badge badge-secondary-indigo badge-circle">
        <i class="cs-icon cs-icon-file-search"></i>
      </div>
      <div class="mt-3">
        <h6 class="d-flex align-items-center justify-content-center gap-2">
          <ng-container i18n>Search Widget</ng-container>
          <app-page-help [articleId]="'ho9v2piyuh'" videoId="-"></app-page-help>
        </h6>
        <p class="text-center" i18n>
          The AdvanceCM Search Widget allows guests to search the availability of your rentals from any website. It
          seamlessly directs guests to a AdvanceCM website for final review and booking. With the search widget you can
          utilize your own non-AdvanceCM website and direct guests to a AdvanceCM website for final booking and
          communication.
        </p>
      </div>
      <div class="flex-fill"></div>
      <button
        routerLink="/widgets/search"
        type="button"
        class="btn btn-secondary-info"
        [disabled]="1 | isReadonlyRole"
        matTooltip="Create or edit a search widget."
        matTooltipPosition="above"
      >
        <span class="cs-icon cs-icon-cog" aria-hidden="true"></span>
        <ng-container i18n>configure</ng-container>
      </button>
    </div>
    <div class="d-flex flex-column align-items-center bg-white p-4 rounded shadow">
      <div class="badge badge-secondary-danger badge-circle">
        <i class="cs-icon cs-icon-file-search"></i>
      </div>
      <div class="mt-3">
        <h6 class="d-flex align-items-center justify-content-center gap-2">
          <ng-container i18n>Interstitial Widget</ng-container>
          <app-page-help [articleId]="'2gaj1ej34d'" videoId="-"></app-page-help>
        </h6>
        <p class="text-center" i18n>
          The AdvanceCM interstitial widget is an all-purpose widget designed to take your guest through the entire
          process from inquiry to booking. You can choose either a button or inline style for this widget and specify
          the values that appear on the results page. Unlike our other options, this widget will present an overlay that
          does not navigate the guest away from your website. Instead, it results in an overlay which will guide the
          user through the booking or inquiry process.
        </p>
      </div>
      <div class="flex-fill"></div>
      <button
        routerLink="/widgets/interstitial"
        type="button"
        class="btn btn-secondary-info"
        [disabled]="1 | isReadonlyRole"
        matTooltip="Create or edit an interstitial widget."
        matTooltipPosition="above"
      >
        <span class="cs-icon cs-icon-cog" aria-hidden="true"></span>
        <ng-container i18n>configure</ng-container>
      </button>
    </div>
  </div>
</section>
